export function getTabContentStyle(currentIndex, nextIndex, previousIndex, ownIndex) {
  const isActive = currentIndex === ownIndex
  const fromLeft = currentIndex < ownIndex
  const toLeft = nextIndex > ownIndex
  const isLeaving = previousIndex === ownIndex
  if ((!isActive && fromLeft) || (isLeaving && !toLeft))
    return 'translate-x-12 opacity-0'
  else if ((!isActive && !fromLeft) || (isLeaving && toLeft))
    return '-translate-x-12 opacity-0'
  else return 'opacity-1 z-10'
}
